export default __webpack_public_path__ + "static/media/figure.06df54d7.gif";